// Default asset-type search router for the "Add asset" dialog.
//
// PowerSync builds run fully offline, where GET /asset-types/search is
// unreachable. When the PowerSync capture adapter is active the dialog
// must hit the local SQLite mirror instead; otherwise it uses the REST
// endpoint. Both paths honour the same request/response contract, so
// the dialog consumes whichever the build selects without branching.
//
// Lives outside the dialog component so the routing decision is unit
// testable without rendering React or pulling in the dialog's import
// graph — the offline-vs-online selection is the core of the offline
// asset-type search fix and is worth protecting directly.

import { searchAssetTypesLocal } from '../../hooks/powersync/search-asset-types-local'
import {
  searchAssetTypes,
  type AssetTypeSearchResponse,
} from '../../hooks/use-classification'
import { POWERSYNC_CAPTURE_CLIENT_ENABLED } from '../client/capture-client-factory'

export function defaultSearch(
  query: string,
  init: { signal: AbortSignal },
): Promise<AssetTypeSearchResponse> {
  if (POWERSYNC_CAPTURE_CLIENT_ENABLED) {
    return searchAssetTypesLocal(query, init)
  }
  return searchAssetTypes({ q: query }, init)
}
